export const oxxioRibbonColors = {
  ribbonBackgroundMediumEmphasis: '{{ secondaryColors.yellow65 }}',
  ribbonColorMediumEmphasis: '{{ textColors.textPrimary }}',

  ribbonBackgroundHighEmphasis: '{{ backgroundColors.backgroundDark }}',
  ribbonColorHighEmphasis: '{{ textColors.textInverted }}',
};
